import './App.css';
import CalculatorQuoteGenerator from './CalculatorQuoteGenerator/CalculatorQuoteGenerator';
import { createTheme, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

function App() {
  const lightTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#000c36',
      },
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '14px',
            backgroundColor: '#000c36',
            color: '#fff',
            borderRadius: '8px',
          },
        },
      },
    },
  });

  return (
    <div className='App'>
      <ThemeProvider theme={lightTheme}>
        <CssBaseline />
        <CalculatorQuoteGenerator />
      </ThemeProvider>
    </div>
  );
}

export default App;
